import moment from "moment";

export const getValue = <T>(item: T, keys: string[]): string | Date => {
  if (keys.length === 1) {
    const value = (item as { [key: string]: any })[keys[0]];
    if (typeof value === "string" && isDateString(value)) {
      return parseDateString(value);
    }
    return value;
  }

  let value: any = item;

  keys.forEach((key) => {
    value = value[key];
  });

  if (typeof value === "string" && isDateString(value)) {
    return parseDateString(value);
  }

  return value;
};

const isDateString = (value: any): boolean => {
  return (
    typeof value === "string" &&
    moment(value, ["DD-MM-YYYY", "DD MMM YYYY"], true).isValid()
  );
};

const parseDateString = (dateString: string): Date => {
  return moment(dateString, ["DD-MM-YYYY", "DD MMM YYYY"]).toDate();
};
